import { memo } from 'react';
import { nullIfEmpty } from '@utils/nullIfEmpty';
import { BigCheckBoxInput } from '../BigCheckBoxInput';
import { BigInputRowDiv, InputList } from '../styles';
import { NOT_APPLICABLE } from './constants';
import { PropsInputSingle, FlattenSingle } from './types';
import { onChangeSingle, showCheckbox } from './utils';

type FirmwareInputSingleProps = PropsInputSingle &
  FlattenSingle<'installedFirmwareVersion' | 'installedSoftwareVersion'>;
function FirmwareInputSingle(props: FirmwareInputSingleProps) {
  const {
    index,
    setFormV,
    installedFirmwareVersion,
    installedSoftwareVersion,
    onlyGroupEdits,
  } = props;

  const firmwareField = `equipments.${index}.installedFirmwareVersion` as const;

  const softwareField = `equipments.${index}.installedSoftwareVersion` as const;

  return (
    <InputList>
      <BigInputRowDiv>
        <BigCheckBoxInput
          isHiddenDisabled={onlyGroupEdits}
          placeholder="Firmware Version"
          value={installedFirmwareVersion ?? ''}
          showCheckbox={showCheckbox(installedFirmwareVersion)}
          isDisabled={installedFirmwareVersion === NOT_APPLICABLE}
          onClick={() => {
            const flippedValue =
              installedFirmwareVersion === NOT_APPLICABLE
                ? null
                : NOT_APPLICABLE;
            onChangeSingle(firmwareField, flippedValue, setFormV);
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const cleanValue = nullIfEmpty.setValueAs(e.target.value);
            onChangeSingle(firmwareField, cleanValue, setFormV);
          }}
        />
      </BigInputRowDiv>

      <BigInputRowDiv>
        <BigCheckBoxInput
          placeholder="Software Version"
          value={installedSoftwareVersion ?? ''}
          isHiddenDisabled={onlyGroupEdits}
          showCheckbox={showCheckbox(installedSoftwareVersion)}
          isDisabled={installedSoftwareVersion === NOT_APPLICABLE}
          onClick={() => {
            const flippedValue =
              installedSoftwareVersion === NOT_APPLICABLE
                ? null
                : NOT_APPLICABLE;
            onChangeSingle(softwareField, flippedValue, setFormV);
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const cleanValue = nullIfEmpty.setValueAs(e.target.value);
            onChangeSingle(softwareField, cleanValue, setFormV);
          }}
        />
      </BigInputRowDiv>
    </InputList>
  );
}
export default memo(FirmwareInputSingle);
